export default "__VITE_ASSET__DvFdZMmz__"